module.exports = __webpack_public_path__ + "static/media/codeguard.8aaaab4f.svg";